import ActiveService from  '@/service.active';

export class uploadAvatarService extends ActiveService{
  /**
   *
   * @param $injector
   * @param $auth
   * @param $translates
   * @param $httpConfigurator
   */
  constructor(
    $injector,
    $auth ,
    $translates ,
    $httpConfigurator
  ){
    'ngInject';
    super($injector);
    this.$auth              = $auth;
    this.$translates        = $translates;
    this.$httpConfigurator  = $httpConfigurator;
  }
  create( avatar ){
    let deferred = this.$q.defer();
    let uri   = this.$auth.user.uris.UploadAvatar;
    window.$.ajax({
      url: uri,
      type: 'POST',
      data: avatar[0],
      cache: false,
      dataType: 'json',
      processData: false,
      contentType: false,
      headers: {
        'X-RapidGAE-Session-User' : this.$auth.getToken()
      },
      success: () => {
        this.notify.set(this.$translates.get('UPLOAD_AVATAR_SENDED'), 'success');
        this.$auth.me();
        deferred.resolve();
      },
      error: ( response ) => {
        if( response.status === 401 ){
          this.$auth.logout();
        }
        if( response.status === 400 ){
          this.notify.set(JSON.parse(response.responseText).error, 'error');
        }
        deferred.reject()
      }
    });
    return deferred.promise;
  }
}


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/upload-avatar/upload-avatar.service.js
 **/